(() => {
  const selectors = {
    root: '[data-dartsrx-product]',
    data: '[data-dartsrx-product-json]',
    variantInput: '[data-dartsrx-variant-input]',
    sellingPlanInput: '[data-dartsrx-selling-plan-input]',
    supplyCard: '[data-dartsrx-supply-card]',
    supplyBadge: '[data-dartsrx-supply-badge]',
    planCard: '[data-dartsrx-plan-card]',
    mainImage: '[data-dartsrx-main-image]',
    thumb: '[data-dartsrx-thumb]',
    galleryPrev: '[data-dartsrx-gallery-prev]',
    galleryNext: '[data-dartsrx-gallery-next]',
    nutritionOpen: '[data-dartsrx-product-nutrition-open]',
    nutritionModal: '[data-dartsrx-product-nutrition-modal]',
    nutritionDialog: '.dartsrx-product__nutrition-dialog',
    nutritionClose: '[data-dartsrx-product-nutrition-close]',
    oneCompare: '[data-dartsrx-one-compare]',
    onePrice: '[data-dartsrx-one-price]',
    subCompare: '[data-dartsrx-sub-compare]',
    subPrice: '[data-dartsrx-sub-price]',
    oneBreakdown: '[data-dartsrx-one-breakdown]',
    subSaving: '[data-dartsrx-sub-saving]',
    subBreakdown: '[data-dartsrx-sub-breakdown]',
    oneDetails: '[data-dartsrx-one-details]',
    subDetails: '[data-dartsrx-sub-details]',
    oneDeliveryText: '[data-dartsrx-one-delivery-text]',
    oneShippingText: '[data-dartsrx-one-shipping-text]',
    deliveryText: '[data-dartsrx-delivery-text]',
    buttonPrice: '[data-dartsrx-button-price]',
    submit: '[type="submit"]',
    guaranteeOpen: '[data-dartsrx-product-guarantee-open]',
    guaranteeModal: '[data-dartsrx-product-guarantee-modal]',
    guaranteeDialog: '.dartsrx-product__guarantee-dialog',
    guaranteeClose: '[data-dartsrx-product-guarantee-close]',
    stickyBuy: '[data-dartsrx-sticky-buy]',
    stickySelection: '[data-dartsrx-sticky-selection]',
    stickyPrice: '[data-dartsrx-sticky-price]',
    stickyReturn: '[data-dartsrx-sticky-return]',
  };

  const moneyFormatRe = /\{\{\s*(\w+)\s*\}\}/;

  const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (Number.isNaN(number) || number == null) return '0';

    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  };

  const formatMoney = (cents, format) => {
    const template = format || '€{{amount}}';
    const match = template.match(moneyFormatRe);

    if (!match) return template;

    let value;

    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount':
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return template.replace(moneyFormatRe, value).replace(/([,.]00)(?!\d)/, '');
  };

  const getSupplyMonths = (variant, index) => {
    const titleNumber = String(variant?.title || '').match(/\d+/);

    if (titleNumber) return titleNumber[0];

    return String(index + 1);
  };

  const updateCompare = (element, compareAt, price, moneyFormat) => {
    if (!element) return;

    element.textContent = formatMoney(compareAt, moneyFormat);
    element.classList.toggle('is-hidden', !compareAt || compareAt <= price);
  };

  const getSavingPercent = (compareAt, price) => {
    if (!compareAt || compareAt <= price) return 0;

    return Math.round(((compareAt - price) / compareAt) * 100);
  };

  const initProduct = (root) => {
    const dataNode = root.querySelector(selectors.data);
    if (!dataNode) return;

    let data;

    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.warn('DartsRx product data could not be parsed.', error);
      return;
    }

    const variants = data.variants || [];
    const form = root.querySelector('form');
    const variantInput = root.querySelector(selectors.variantInput);
    const supplyCards = [...root.querySelectorAll(selectors.supplyCard)];
    const planCards = [...root.querySelectorAll(selectors.planCard)];
    const mainImage = root.querySelector(selectors.mainImage);
    const mainMedia = mainImage?.closest('.dartsrx-product__main-media');
    const oneCompare = root.querySelector(selectors.oneCompare);
    const onePrice = root.querySelector(selectors.onePrice);
    const subCompare = root.querySelector(selectors.subCompare);
    const subPrice = root.querySelector(selectors.subPrice);
    const oneBreakdown = root.querySelector(selectors.oneBreakdown);
    const subSaving = root.querySelector(selectors.subSaving);
    const subBreakdown = root.querySelector(selectors.subBreakdown);
    const oneDetails = root.querySelector(selectors.oneDetails);
    const subDetails = root.querySelector(selectors.subDetails);
    const oneDeliveryText = root.querySelector(selectors.oneDeliveryText);
    const oneShippingText = root.querySelector(selectors.oneShippingText);
    const deliveryText = root.querySelector(selectors.deliveryText);
    const buttonPrice = root.querySelector(selectors.buttonPrice);
    const submit = root.querySelector(selectors.submit);
    const thumbs = [...root.querySelectorAll(selectors.thumb)];
    const galleryPrev = root.querySelector(selectors.galleryPrev);
    const galleryNext = root.querySelector(selectors.galleryNext);
    const nutritionOpen = root.querySelector(selectors.nutritionOpen);
    const nutritionModal = root.querySelector(selectors.nutritionModal);
    const nutritionDialog = root.querySelector(selectors.nutritionDialog);
    const nutritionCloseButtons = root.querySelectorAll(selectors.nutritionClose);
    const guaranteeOpen = root.querySelector(selectors.guaranteeOpen);
    const guaranteeModal = root.querySelector(selectors.guaranteeModal);
    const guaranteeDialog = root.querySelector(selectors.guaranteeDialog);
    const guaranteeCloseButtons = root.querySelectorAll(selectors.guaranteeClose);
    const stickyBuy = root.querySelector(selectors.stickyBuy);
    const stickySelection = root.querySelector(selectors.stickySelection);
    const stickyPrice = root.querySelector(selectors.stickyPrice);
    const stickyReturn = root.querySelector(selectors.stickyReturn);
    const originalModalParent = nutritionModal?.parentElement;
    const originalModalNextSibling = nutritionModal?.nextSibling;
    const originalGuaranteeParent = guaranteeModal?.parentElement;
    const originalGuaranteeNextSibling = guaranteeModal?.nextSibling;

    if (!variants.length || !variantInput || !form) return;

    if (stickyBuy) {
      document.querySelectorAll('body > [data-dartsrx-sticky-buy]').forEach((existingStickyBuy) => {
        if (existingStickyBuy !== stickyBuy) existingStickyBuy.remove();
      });

      document.body.append(stickyBuy);
    }

    let selectedVariantId = Number(data.defaultVariantId || variants[0].id);
    let activeThumbIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const getVariant = () => variants.find((variant) => Number(variant.id) === Number(selectedVariantId)) || variants[0];

    const getSellingPlanInput = () => {
      let input = root.querySelector(selectors.sellingPlanInput) || form.querySelector('input[name="selling_plan"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-dartsrx-selling-plan-input', '');
        form.append(input);
      }

      return input;
    };

    const getPlanValue = () => {
      const checkedPlan = root.querySelector('input[name="dartsrx_plan"]:checked');
      return checkedPlan ? checkedPlan.value : 'one-time';
    };

    const getOneTimeShippingText = () => {
      const countryCode = String(data.countryCode || '').toUpperCase();
      return data.oneTimeShipping?.[countryCode] || data.oneTimeShipping?.default || '';
    };

    const updatePlanCards = (activePlan, variant) => {
      planCards.forEach((card) => {
        const input = card.querySelector('input');
        if (!input) return;

        if (input.value === 'subscribe') {
          input.disabled = !variant.sellingPlan;
        }

        card.classList.toggle('is-active', input.value === activePlan);
      });
    };

    const updateSupplyCards = (activePlan) => {
      supplyCards.forEach((card) => {
        const input = card.querySelector('input');
        const badge = card.querySelector(selectors.supplyBadge);
        const isActive = input && Number(input.value) === Number(selectedVariantId);

        card.classList.toggle('is-active', isActive);

        if (badge) {
          badge.textContent =
            activePlan === 'subscribe' ? card.dataset.subscribeBadge || '' : card.dataset.oneTimeBadge || '';
        }
      });
    };

    const updateImage = (variant) => {
      if (data.customGallery) return;
      if (!mainImage || !variant.image) return;

      mainImage.src = variant.image;
      mainImage.removeAttribute('srcset');
    };

    const sync = () => {
      const variant = getVariant();
      let activePlan = getPlanValue();

      if (activePlan === 'subscribe' && !variant.sellingPlan) {
        const oneTimeInput = root.querySelector('input[name="dartsrx_plan"][value="one-time"]');
        if (oneTimeInput) oneTimeInput.checked = true;
        activePlan = 'one-time';
      }

      const subscriptionSelected = activePlan === 'subscribe' && variant.sellingPlan;
      const activePrice = subscriptionSelected ? variant.sellingPlan.price : variant.price;
      const activeCompare = variant.compareAtPrice || variant.price;
      const supplyIndex = variants.findIndex((item) => Number(item.id) === Number(variant.id));
      const months = getSupplyMonths(variant, supplyIndex);
      const bottleCount = Number(months) || supplyIndex + 1 || 1;
      const bottleLabel = `${bottleCount} ${bottleCount === 1 ? 'bottle' : 'bottles'}`;
      const subscriptionSaving = getSavingPercent(activeCompare, variant.sellingPlan?.price || variant.price);

      variantInput.value = variant.id;
      variantInput.disabled = false;

      const sellingPlanInput = getSellingPlanInput();

      if (sellingPlanInput) {
        if (subscriptionSelected) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = variant.sellingPlan.id;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }
      }

      updateSupplyCards(activePlan);
      updatePlanCards(activePlan, variant);
      updateImage(variant);

      if (onePrice) onePrice.textContent = formatMoney(variant.price, data.moneyFormat);
      if (subPrice) subPrice.textContent = formatMoney(variant.sellingPlan?.price || variant.price, data.moneyFormat);
      if (buttonPrice) buttonPrice.textContent = formatMoney(activePrice, data.moneyFormat);
      if (stickySelection) {
        stickySelection.textContent = `${bottleLabel} · ${
          subscriptionSelected ? 'Subscribe & Save' : 'One-Time Purchase'
        }`;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(activePrice, data.moneyFormat);
      if (oneBreakdown) {
        oneBreakdown.hidden = bottleCount <= 1;
        oneBreakdown.textContent =
          bottleCount > 1 ? `${formatMoney(Math.round(variant.price / bottleCount), data.moneyFormat)} per bottle` : '';
      }
      if (subBreakdown) {
        const subscriptionPrice = variant.sellingPlan?.price || variant.price;
        subBreakdown.hidden = bottleCount <= 1;
        subBreakdown.textContent =
          bottleCount > 1 ? `${formatMoney(Math.round(subscriptionPrice / bottleCount), data.moneyFormat)} per bottle` : '';
      }
      if (subSaving) {
        subSaving.textContent = subscriptionSaving
          ? `Save ${subscriptionSaving}% + free shipping`
          : 'Free shipping';
      }

      updateCompare(oneCompare, activeCompare, variant.price, data.moneyFormat);
      updateCompare(subCompare, activeCompare, variant.sellingPlan?.price || variant.price, data.moneyFormat);

      if (oneDeliveryText) {
        oneDeliveryText.textContent = `${bottleLabel} delivered once`;
      }

      if (oneShippingText) {
        oneShippingText.textContent = getOneTimeShippingText();
      }

      if (deliveryText) {
        deliveryText.textContent = `${bottleLabel} delivered every ${months} ${months === '1' ? 'month' : 'months'}`;
      }

      if (oneDetails) {
        oneDetails.hidden = subscriptionSelected;
      }

      if (subDetails) {
        subDetails.hidden = !subscriptionSelected;
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.toggleAttribute('disabled', !variant.available);
      }

      if (stickyReturn) {
        stickyReturn.setAttribute('aria-disabled', String(!variant.available));
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name="dartsrx_supply"]')) {
        selectedVariantId = Number(event.target.value);
      }

      if (
        event.target.matches('input[name="dartsrx_supply"]') ||
        event.target.matches('input[name="dartsrx_plan"]')
      ) {
        sync();
      }
    });

    form.addEventListener(
      'submit',
      () => {
        sync();
      },
      true
    );

    form.addEventListener('formdata', (event) => {
      const variant = getVariant();
      const subscriptionSelected = getPlanValue() === 'subscribe' && variant.sellingPlan;

      event.formData.set('id', String(variant.id));
      event.formData.delete('dartsrx_supply');
      event.formData.delete('dartsrx_plan');

      if (subscriptionSelected) {
        event.formData.set('selling_plan', String(variant.sellingPlan.id));
      } else {
        event.formData.delete('selling_plan');
      }
    });

    const setActiveThumb = (index) => {
      if (!thumbs.length || !mainImage) return;

      activeThumbIndex = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[activeThumbIndex];
      const image = activeThumb?.dataset.image;

      if (!image) return;

      thumbs.forEach((item) => item.classList.remove('is-active'));
      activeThumb.classList.add('is-active');
      mainImage.src = image;
      mainImage.removeAttribute('srcset');
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => {
        const image = thumb.dataset.image;
        if (!image || !mainImage) return;

        setActiveThumb(thumbIndex);
      });
    });

    if (mainMedia && thumbs.length > 1) {
      const swipeState = {
        active: false,
        pointerId: null,
        startX: 0,
        startY: 0,
      };

      const releaseSwipeCapture = (pointerId) => {
        if (pointerId === null || !mainMedia.hasPointerCapture?.(pointerId)) return;

        try {
          mainMedia.releasePointerCapture(pointerId);
        } catch {
          return;
        }
      };

      const resetSwipe = (event) => {
        releaseSwipeCapture(swipeState.pointerId);

        swipeState.active = false;
        swipeState.pointerId = null;
        swipeState.startX = 0;
        swipeState.startY = 0;

        releaseSwipeCapture(event?.pointerId ?? null);
      };

      mainMedia.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' || event.button !== 0) return;

        swipeState.active = true;
        swipeState.pointerId = event.pointerId;
        swipeState.startX = event.clientX;
        swipeState.startY = event.clientY;
        mainMedia.setPointerCapture?.(event.pointerId);
      });

      mainMedia.addEventListener('pointerup', (event) => {
        if (!swipeState.active || swipeState.pointerId !== event.pointerId) return;

        const deltaX = event.clientX - swipeState.startX;
        const deltaY = event.clientY - swipeState.startY;

        resetSwipe(event);

        if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

        setActiveThumb(activeThumbIndex + (deltaX < 0 ? 1 : -1));
      });

      mainMedia.addEventListener('pointercancel', resetSwipe);
      mainMedia.addEventListener('lostpointercapture', resetSwipe);
    }

    galleryPrev?.addEventListener('click', () => setActiveThumb(activeThumbIndex - 1));
    galleryNext?.addEventListener('click', () => setActiveThumb(activeThumbIndex + 1));

    if (stickyBuy && stickyReturn && submit) {
      stickyBuy.hidden = false;

      let stickyFrame = null;

      const updateStickyVisibility = () => {
        stickyFrame = null;
        const submitRect = submit.getBoundingClientRect();
        const stickyShouldShow = submitRect.bottom < 80;

        stickyBuy.classList.toggle('is-visible', stickyShouldShow);
        stickyBuy.setAttribute('aria-hidden', String(!stickyShouldShow));
        document.body.classList.toggle('dartsrx-sticky-buy-visible', stickyShouldShow);
      };

      const requestStickyUpdate = () => {
        if (stickyFrame !== null) return;
        stickyFrame = window.requestAnimationFrame(updateStickyVisibility);
      };

      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate, { passive: true });

      stickyReturn.addEventListener('click', (event) => {
        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        submit.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center'
        });

        window.setTimeout(
          () => submit.focus({ preventScroll: true }),
          reduceMotion ? 0 : 420
        );
      });

      updateStickyVisibility();
    }

    const closeNutritionModal = () => {
      if (!nutritionModal || nutritionModal.hidden) return;

      nutritionModal.hidden = true;
      nutritionModal.classList.remove('is-open');
      document.documentElement.classList.remove('dartsrx-modal-open');
      document.body.classList.remove('dartsrx-modal-open');

      if (originalModalParent && nutritionModal.parentElement !== originalModalParent) {
        originalModalParent.insertBefore(nutritionModal, originalModalNextSibling);
      }

      nutritionOpen?.focus();
    };

    const openNutritionModal = () => {
      if (!nutritionModal) return;

      if (nutritionModal.parentElement !== document.body) {
        document.body.appendChild(nutritionModal);
      }

      nutritionModal.hidden = false;
      nutritionModal.classList.add('is-open');
      document.documentElement.classList.add('dartsrx-modal-open');
      document.body.classList.add('dartsrx-modal-open');
      nutritionDialog?.focus();
    };

    const closeGuaranteeModal = () => {
      if (!guaranteeModal || guaranteeModal.hidden) return;

      guaranteeModal.hidden = true;
      guaranteeModal.classList.remove('is-open');
      document.documentElement.classList.remove('dartsrx-modal-open');
      document.body.classList.remove('dartsrx-modal-open');

      if (originalGuaranteeParent && guaranteeModal.parentElement !== originalGuaranteeParent) {
        originalGuaranteeParent.insertBefore(guaranteeModal, originalGuaranteeNextSibling);
      }

      guaranteeOpen?.focus();
    };

    const openGuaranteeModal = () => {
      if (!guaranteeModal) return;

      if (guaranteeModal.parentElement !== document.body) {
        document.body.appendChild(guaranteeModal);
      }

      guaranteeModal.hidden = false;
      guaranteeModal.classList.add('is-open');
      document.documentElement.classList.add('dartsrx-modal-open');
      document.body.classList.add('dartsrx-modal-open');
      guaranteeDialog?.focus();
    };

    nutritionOpen?.addEventListener('click', openNutritionModal);
    nutritionCloseButtons.forEach((button) => button.addEventListener('click', closeNutritionModal));
    guaranteeOpen?.addEventListener('click', openGuaranteeModal);
    guaranteeCloseButtons.forEach((button) => button.addEventListener('click', closeGuaranteeModal));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeNutritionModal();
        closeGuaranteeModal();
      }
    });

    sync();
  };

  document.querySelectorAll(selectors.root).forEach(initProduct);
})();
